import { CharterPartyPerformanceScreen } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import { officeVoyageSource } from '../voyage-source.js';

/** Charter Party Performance: ortak ekran (ADR 0022 §4); performans gönderilmiş raporlardan, salt okunur. */
export function CharterPartyPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('voyage.charterParty.title')}>
      <CharterPartyPerformanceScreen source={officeVoyageSource} />
    </Shell>
  );
}
